<!-- 定义全局变量 -->
<script type="text/javascript">
// ******默认url链接********

	// var urlBase="http://192.168.1.18:7072/api";   //陈勇
var urlBase="http://m-ahjgjt.zpcp.org.cn/api";   //陈勇
// var urlBase="https://m-ahjgjxjy.com/api";               //正式
// var urlBase="m-redis.ahsjxjy.com/api";
// var urlBase="http://weixin.ahsjxjy.com/api";          //微信测试
  //  var urlBase="http://192.168.1.90:8080/";
// ******图片链接********
var imgBase="https://www.ahsjxjy.com";

export default
{
  urlBase,
  imgBase
}
</script>



// WEBPACK FOOTER //
// global.vue?7d6cd2dc